import MoreVertIcon from "@mui/icons-material/MoreVert"
import { useApi } from "auth/useApi3"
import React, { useContext, useEffect, useState } from "react"

import Button from "components/Button"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { UserForm } from "shared/customer/UserForm"

import {
  Box,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from "@mui/material"
import SubTabs from "components/SubTabs"
import { TabPanel } from "components/navigation/TabPanel"
import { allRoutes } from "generated/routes"
import { useHistory } from "react-router-dom"
import { UserCustomFieldValues } from "./UserCustomFieldValues"
import { useTranslation } from "react-i18next"

const EditUser = ({ match }) => {
  const [customerResult, getCustomerApi] = useApi()
  const [userResult, getUserApi] = useApi()
  const [updateUserResult, updateUserApi] = useApi()
  const [deleteResult, deleteUserApi] = useApi()
  const loadingContext = useContext(GlobalLoaderContext)
  const routerHistory = useHistory()
  const [tabValue, setTabValue] = useState(0)
  const { t } = useTranslation()

  const tabData = [
    { index: 0, label: t("settings.user.user_information", "User information"), queryParam: "info" },
    { index: 1, label: t("global.custom_fields", "Custom fields"), queryParam: "customFields" }
  ]

  useEffect(() => {
    // redirect back to list
    if (deleteResult.status === 2) routerHistory.push(allRoutes.CustomerSettingsUsers())
  }, [deleteResult.status, routerHistory])

  useEffect(() => {
    loadStuff()
  }, [match, getCustomerApi, getUserApi])

  useEffect(() => {
    loadingContext.setLoading(() => customerResult.status === 1)
  })

  useEffect(async () => {
    if (updateUserResult.status === 2)
      await getUserApi.get(apiEndpoints.customeradmin.getuserbyid.replace("{id}", match.params.id))
  }, [updateUserResult])

  const handleSubmit = (saveUser) => {
    updateUserApi.put(apiEndpoints.customeradmin.updateuser, saveUser)
  }

  useEffect(() => {
    if (updateUserResult.status !== 2) return
    loadStuff()
  }, [updateUserResult])

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const openSettingsDropdown = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const closeSettingsDropdown = () => {
    setAnchorEl(null)
  }

  const [dialogOpen, setDialogOpen] = React.useState(false)

  const openRemoveDialog = () => {
    deleteUserApi.reset()
    setDialogOpen(true)
  }

  const closeRemoveDialog = () => {
    deleteUserApi.reset()
    setDialogOpen(false)
  }

  const loadStuff = async () => {
    await getCustomerApi.get(apiEndpoints.customeradmin.getcustomer)
    await getUserApi.get(apiEndpoints.customeradmin.getuserbyid.replace("{id}", match.params.id))
  }

  return (
    <div>
      <Container>
        <Box mb={4}>
          <Grid item container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h2">{t("settings.user.edit_user", "Edit user")}</Typography>
            <IconButton
              aria-label="Settings"
              aria-controls="settings-menu"
              aria-haspopup="true"
              onClick={openSettingsDropdown}
              size="medium">
              <MoreVertIcon fontSize="medium" />
            </IconButton>
            <Menu id="settings-menu" anchorEl={anchorEl} open={open} onClose={closeSettingsDropdown}>
              <MenuItem
                onClick={() => {
                  routerHistory.push(allRoutes.CustomerSettingsUsersEditPasswordreset(match.params.id))
                }}>
                {t("settings.user.set_new_password", "Set new password")}
              </MenuItem>
              <MenuItem onClick={openRemoveDialog}>{t("settings.user.delete_user", "Delete user")}</MenuItem>
            </Menu>
          </Grid>
        </Box>

        <Grid container ml={1}>
          <Grid item xs={12}>
            <SubTabs tabs={tabData} value={tabValue} setValue={setTabValue} />
          </Grid>
        </Grid>
        <TabPanel value={tabValue} index={0}>
          {userResult.status === 2 && customerResult.status === 2 ? (
            <UserForm
              initialValues={userResult.data}
              customer={customerResult.data}
              onSubmit={handleSubmit}
              result={updateUserResult}
            />
          ) : null}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <UserCustomFieldValues userResult={userResult} />
        </TabPanel>
      </Container>
      <Dialog
        open={dialogOpen}
        onClose={closeSettingsDropdown}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{"Ta bort användare?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t(
              "settings.user.are_you_sure_delete_user",
              "Are you sure you want to delete users? Your choice cannot be undone."
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeRemoveDialog} variant="outlined">
            {t("global.cancel", "Cancel")}
          </Button>
          <Button
            result={deleteResult}
            onClick={() => {
              deleteUserApi.del(apiEndpoints.customeradmin.deleteuser.replace("{id}", match.params.id))
            }}
            color="primary"
            autoFocus>
            {t("global.yes_im_sure", "Yes, I'm sure")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
export default EditUser
